<div class="modal">
  <div class="modal-overlay" (click)="cancel($event)"></div>

  <div class="modal-dialog" role="document">
    <div class=" modal-content">

      <div class="modal-header">
        <span class="modal-title">{{ modalTitle }}</span>
        <span class="me-auto"></span>
        <i class="btn btn-danger bi bi-x-lg" (click)="cancel($event)"></i>
      </div>

      <div class="modal-body">
        <div class="m-3">
          @for (addressItem of addressList; track addressItem) {
            <app-address-detail [address]="addressItem" [isHeaderVisible]="false" (click)="select(addressItem)">
            </app-address-detail>
            @for (addresstour of addressItem.tourList; track addresstour; let i = $index) {
              <app-delivery-reminder [addresstour]="addresstour" [address]="addressItem" [index]="i"></app-delivery-reminder>
            }
          }
        </div>
      </div>

      <div class="modal-footer">
        <button type="button" class="btn btn-success" data-bs-dismiss="modal" (click)="submit($event)">{{
        submitButtonLabel }}</button>
      </div>

    </div>
  </div>
</div>
